<ng-container *ngFor="let breadcrumb of navigationList; let last = last">
  <div class="page-header" *ngIf="last && breadcrumb.breadcrumbs !== false">
    <div class="page-block">
      <div class="row align-items-center">
        <div class="col-md-12">
          <div class="page-header-title">
            <ng-container *ngFor="let breadcrumb of navigationList; let last = last">
              <h5 class="m-b-10" *ngIf="last">{{ (breadcrumb.title.length>40)? (breadcrumb.title | slice:0:40)+'..':(breadcrumb.title) }}
                <small style="font-size:0.6em" class="text-muted" *ngIf="updatedAt"> - l'ultima modifica è stata apportata: {{updatedAt}}</small>
              </h5>
            </ng-container>
          </div>
          <ul class="breadcrumb">
            <li class="breadcrumb-item">
              <a [routerLink]="['/dashboard/default/']" *ngIf="type === 'theme2'"><i class="feather icon-home"></i></a>
              <a [routerLink]="['/dashboard/default/']" *ngIf="type === 'theme1'">Home</a>
            </li>
            <ng-container *ngFor="let breadcrumb of navigationList">
              <li class="breadcrumb-item" *ngIf="breadcrumb.url !== false"><a [routerLink]="breadcrumb.url">{{ (breadcrumb.title.length>40)? (breadcrumb.title | slice:0:40)+'..':(breadcrumb.title) }}</a></li>
              <li class="breadcrumb-item" *ngIf="breadcrumb.url === false"><a href="javascript:">{{ (breadcrumb.title.length>40)? (breadcrumb.title | slice:0:40)+'..':(breadcrumb.title) }}</a></li>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>
  </div>
</ng-container>
